import { StudyAreaStatus } from "src/app/predictor/enums/study-area-status";
import { StudyArea, StudyAreaCommentRequest } from "src/app/predictor/interfaces/study-area";
export namespace ManagerActions {
  export class GetStudyAreas {
    constructor(public pageNumber?: number) {
    }
    static readonly type = '[DebrisFlow Manager] GetStudyAreas';
  }

  export class GetAllStudyAreas {
    static readonly type = '[DebrisFlow Manager] Get All Study Areas';
  }

  export class ChangePageIndex {
    constructor(public pageIndex: number) { }
    static readonly type = '[DebrisFlow Manager] ChangePageIndex';
  }

  export class ChangePageSize {
    constructor(public pageSize: number) { }
    static readonly type = '[DebrisFlow Manager] ChangePageSize';
  }

  export class UpdateStudyAreaStatus {
    constructor(
      public studyArea: StudyArea,
      public status: StudyAreaStatus,
      public callbackOnError?: (error: string) => void,
      public callbackOnSuccess?: () => void
    ) { }
    static readonly type = '[DebrisFlow Manager] Update study area paid status';

    static readonly success = 'Study area\'s status has been updated.';
    static readonly error = 'An error occurred updating study area.';
  }

  export class DeleteStudyArea {
    constructor(public studyArea: StudyArea) { }
    static readonly type = '[DebrisFlow Manager] Delete study area.';

    static readonly success = 'Study area has been deleted.';
    static readonly error = 'An error occurred deleting study area.';
  }

  export class UpdateStudyAreaComment {
    constructor(public request: StudyAreaCommentRequest) { }
    static readonly type = '[DebrisFlow Manager] Comment on study area.';

    static readonly success = 'Study area has been updated.';
    static readonly error = 'An error occurred updating study area.';
  }
}
